import { store } from '@/decorators/store';
import { Features } from '@/entities/Features';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'Features' })
export class FeaturesStore extends AbstractEntityStore<Features> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
